import {Day} from '../app/shared/CoreClient';
import moment from 'moment';

export const formatDay = (day: Day): string => {
  const date = moment(day.substring(1));

  return date.format('dddd Do MMMM, YYYY');
};
